export const clx = (...classNames: (string | undefined)[]) => classNames.filter(Boolean).join(" ");
